// file: src/utils/pdfGenerator.js
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// Fungsi khusus untuk memperbaiki tabel dengan rowspan/colspan
const fixTableHeaders = (element) => {
  console.log('Fixing table headers with rowspan...');
  
  const tables = element.querySelectorAll('.table-form');
  tables.forEach((table, tableIndex) => {
    console.log(`Processing table ${tableIndex + 1}`);
    
    // Fix untuk header dengan rowspan
    const headerRows = table.querySelectorAll('tr.section-title');
    headerRows.forEach((row, rowIndex) => {
      const cells = row.querySelectorAll('td, th');
      console.log(`Row ${rowIndex + 1} has ${cells.length} cells`);
      
      cells.forEach((cell, cellIndex) => {
        const rowspan = parseInt(cell.getAttribute('rowspan')) || 1;
        const colspan = parseInt(cell.getAttribute('colspan')) || 1;
        
        if (rowspan > 1 || colspan > 1) {
          console.log(`Cell ${cellIndex} has rowspan:${rowspan}, colspan:${colspan}`);
          
          // Force styles untuk cells dengan rowspan/colspan
          Object.assign(cell.style, {
            visibility: 'visible',
            display: 'table-cell',
            opacity: '1',
            background: '#f8f9fa',
            border: '1px solid #000',
            position: 'relative',
            zIndex: '10'
          });
          
          // Pastikan teks visible
          const text = cell.textContent || cell.innerText;
          if (text.trim()) {
            console.log(`Cell content: "${text.trim()}"`);
          }
        }
        
        // Force semua header cells visible
        Object.assign(cell.style, {
          visibility: 'visible',
          opacity: '1',
          background: cell.style.background || '#f8f9fa'
        });
      });
    });
    
    // Fix untuk data rows
    const dataRows = table.querySelectorAll('tr.plot-data-row');
    dataRows.forEach(row => {
      const cells = row.querySelectorAll('td');
      cells.forEach(cell => {
        Object.assign(cell.style, {
          visibility: 'visible',
          opacity: '1'
        });
      });
    });
  });
};

export const generatePersenBungaPDFFromDOM = async (groupData) => {
  try {
    console.log('Generating PDF dengan optimasi footer...');
    
    const pdf = new jsPDF('l', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    
    const containers = document.querySelectorAll('.container');
    console.log('Containers found:', containers.length);
    
    if (containers.length < 2) {
      throw new Error(`Form containers not found. Found: ${containers.length}`);
    }

    // Pre-rendering preparation
    console.log('Pre-rendering elements dengan fokus pada footer...');
    for (let i = 0; i < containers.length; i++) {
      const container = containers[i];
      
      // Scroll ke container dan beri waktu untuk render footer
      container.scrollIntoView({ behavior: 'smooth', block: 'start' });
      
      // Scroll khusus ke footer untuk memastikan ter-render
      const footer = container.querySelector('.doc-footer');
      if (footer) {
        footer.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
      
      await delay(1000);
    }
    await delay(2000);

    for (let i = 0; i < containers.length; i++) {
      if (i > 0) {
        pdf.addPage();
      }

      const container = containers[i];
      console.log(`Processing container ${i + 1}...`);
      
      // Simpan style asli
      const originalStyles = {
        width: container.style.width,
        margin: container.style.margin,
        padding: container.style.padding,
        position: container.style.position,
        visibility: container.style.visibility,
        background: container.style.background
      };
      
      // Optimasi container TANPA mengubah layout yang sudah ada
      Object.assign(container.style, {
        visibility: 'visible',
        background: 'white',
        zIndex: '1000'
      });

      // Scroll dan tunggu untuk memastikan footer ter-render
      container.scrollIntoView({ behavior: 'instant', block: 'start' });
      
      // Scroll khusus ke footer
      const footer = container.querySelector('.doc-footer');
      if (footer) {
        footer.scrollIntoView({ behavior: 'instant', block: 'end' });
      }
      
      await delay(1500);
      
      // PERBAIKAN KHUSUS: Fix table headers sebelum capture
      fixTableHeaders(container);
      
      // Force reflow
      void container.offsetHeight;
      
      console.log(`Capturing container ${i + 1}...`);
      
      const canvas = await html2canvas(container, {
        scale: 2,
        useCORS: true,
        allowTaint: false,
        backgroundColor: '#ffffff',
        logging: true,
        width: container.scrollWidth,
        height: container.scrollHeight + 20, // Tambahan sedikit height untuk memastikan footer tidak terpotong
        scrollX: 0,
        scrollY: -window.scrollY,
        windowWidth: container.scrollWidth,
        windowHeight: container.scrollHeight + 20,
        onclone: (clonedDoc, element) => {
          console.log('Cloning element dengan optimasi footer...');
          
          // Optimasi container clone TANPA mengubah layout
          Object.assign(element.style, {
            visibility: 'visible',
            background: 'white',
            position: 'relative'
          });
          
          // Optimasi khusus untuk footer dalam clone
          const clonedFooter = element.querySelector('.doc-footer');
          if (clonedFooter) {
            // Hanya tambahkan properti yang diperlukan untuk PDF tanpa mengubah layout
            Object.assign(clonedFooter.style, {
              visibility: 'visible',
              background: 'white',
              zIndex: '1001'
            });
          }
          
          // PERBAIKAN PENTING: Fix tables dalam clone
          const tables = element.querySelectorAll('.table-form');
          tables.forEach(table => {
            // Force table layout untuk PDF
            Object.assign(table.style, {
              visibility: 'visible',
              display: 'table',
              borderCollapse: 'collapse',
              width: '100%'
            });
            
            // Fix semua header cells dengan rowspan
            const allCells = table.querySelectorAll('td, th');
            allCells.forEach(cell => {
              const rowspan = cell.getAttribute('rowspan');
              const colspan = cell.getAttribute('colspan');
              
              if (rowspan || colspan) {
                console.log('Found cell with rowspan/colspan in clone:', {
                  rowspan,
                  colspan,
                  text: cell.textContent?.trim()
                });
                
                Object.assign(cell.style, {
                  visibility: 'visible',
                  display: 'table-cell',
                  opacity: '1',
                  background: '#f5f5f5',
                  border: '2px solid #000',
                  fontWeight: 'bold',
                  position: 'relative',
                  zIndex: '100'
                });
              }
              
              // Force semua cells visible
              Object.assign(cell.style, {
                visibility: 'visible',
                opacity: '1'
              });
            });
            
            // Khusus untuk section title rows
            const sectionTitles = table.querySelectorAll('.section-title');
            sectionTitles.forEach(row => {
              Object.assign(row.style, {
                visibility: 'visible',
                background: '#e9ecef'
              });
            });
          });
          
          // Add minimal CSS untuk memastikan visibility tanpa mengubah layout
          const style = document.createElement('style');
          style.textContent = `
            * {
              visibility: visible !important;
            }
            .table-form {
              border-collapse: collapse !important;
            }
            .td-form, th {
              border: 1px solid #000 !important;
            }
          `;
          clonedDoc.head.appendChild(style);
        }
      });

      console.log(`Container ${i + 1} captured:`, canvas.width, 'x', canvas.height);
      
      // Debug: Check if footer area is captured
      const ctx = canvas.getContext('2d');
      const footerAreaHeight = 150; // Area lebih besar untuk footer
      const footerImageData = ctx.getImageData(0, canvas.height - footerAreaHeight, canvas.width, footerAreaHeight);
      let footerHasContent = false;
      for (let i = 0; i < footerImageData.data.length; i += 4) {
        if (footerImageData.data[i] < 250 || footerImageData.data[i + 1] < 250 || footerImageData.data[i + 2] < 250) {
          footerHasContent = true;
          break;
        }
      }
      console.log(`Footer area has content: ${footerHasContent}`);
      
      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      
      // Pastikan gambar tidak melebihi tinggi halaman PDF
      const finalImgHeight = Math.min(imgHeight, pdfHeight - 5); // Sedikit margin
      
      pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, finalImgHeight);
      console.log(`Container ${i + 1} added to PDF dengan height: ${finalImgHeight}`);
      
      // Kembalikan style asli
      Object.assign(container.style, originalStyles);
      
      await delay(800);
    }

    const fileName = `Laporan-Persen-Bunga-${groupData.lokasi}.pdf`;
    pdf.save(fileName);
    console.log('PDF dengan footer fix berhasil didownload');

    return true;

  } catch (error) {
    console.error('Error generating PDF:', error);
    throw error;
  }
};